import React, { useState } from "react";
import { Button, ClockRewind } from "@opendate-app/setlist";

import { useBroadcastEditContext } from "./BroadcastEditContainer";
import TemplateEditor from "../BeefreeTemplates/TemplateEditor";
import VersionHistoryPanel from "./VersionHistoryPanel";
import InlineEditField from "./InlineEditField";

const styles = {
  container: {
    boxShadow: "var(--sl-shadow-sm)",
    display: "flex",
    flexDirection: "column",
  },
  editorHeaderRow: {
    alignItems: "center",
    backgroundColor: "var(--sl-bg-primary)",
    borderBottom: "1px solid var(--sl-border-subtle)",
    color: "var(--sl-text-primary)",
    display: "flex",
    flexWrap: "wrap",
    gap: 16,
    padding: 16,
  },
  versionHistory: {
    marginLeft: "auto",
  },
};

const EmailContentTab = () => {
  const {
    broadcast,
    subject,
    setSubject,
    preheader,
    setPreheader,
    updateBroadcast,
    autosaveTemplate,
    sendDomain,
    emailMergeTags,
  } = useBroadcastEditContext();

  const [showVersionHistory, setShowVersionHistory] = useState(false);

  return (
    <div style={styles.container}>
      <div style={styles.editorHeaderRow}>
        <div><b>From: </b>{sendDomain?.name_with_address}</div>
        <InlineEditField
          label={<b>Subject:</b>}
          fieldName="subject"
          value={subject}
          onChange={setSubject}
          onSave={() => updateBroadcast({ broadcast: { subject: subject } })}
          onCancel={() => setSubject(broadcast.subject)}
        />
        <InlineEditField
          label={<b>Preheader:</b>}
          fieldName="preheader"
          value={preheader}
          onChange={setPreheader}
          onSave={() => updateBroadcast({ broadcast: { preheader: preheader } })}
          onCancel={() => setPreheader(broadcast.preheader)}
        />
        <div style={styles.versionHistory}>
          <Button size="sm" icon={ClockRewind} onClick={() => setShowVersionHistory(true)}>
            Version history
          </Button>
        </div>
      </div>
      <TemplateEditor
        templatableContext={useBroadcastEditContext}
        autosave
        onAutosave={autosaveTemplate}
        mergeTags={emailMergeTags}
      />
      {showVersionHistory && (
        <VersionHistoryPanel onClose={() => setShowVersionHistory(false)} />
      )}
    </div>
  );
};

export default EmailContentTab;
